/* DeleteAction.js */

"use strict";

const IMAGE_NAME_MAX_LENGTH = 60;

class DeleteAction {
    constructor(logger, gameEditor) {
        this._logger = logger;
        this._gameEditor = gameEditor;
        this.doTheThang = this.doTheThang.bind(this);
    }

    run() {
        let imageName = this._gameEditor.getOsImage().name;
        let shortImageName = imageName.length > IMAGE_NAME_MAX_LENGTH ? imageName.substr(0, IMAGE_NAME_MAX_LENGTH) + "…" : imageName;
        return this._gameEditor
            .runQuickConfirmationActionWorkflow(
                {
                    message: 'Are you sure you want to permanently delete "' + shortImageName + '"?',
                    title: "Delete",
                    confirmDetails: {
                        text: "Confirm",
                        type: "destructive"
                    },
                    rejectDetails: {
                        text: "Cancel",
                        type: "text"
                    }
                },
                this.doTheThang
            )
            .finally(() => {
                if (this._gameEditor.currentEntityRemoved) {
                    this._gameEditor.currentEntityRemoved = false;
                    this._gameEditor.currentEntityDeleteInProgress = false;
                    this._gameEditor.closeEditor(this._gameEditor.editorTabStateId, true);
                }
            });
    }

    doTheThang() {
        return this._gameEditor
            .getOsImage()
            .delete()
            .catch((err) => {
                this._logger.warn({ error: err }, "DeleteAction.run() - Error");
                this._gameEditor.currentEntityDeleteInProgress = false;
                return Promise.reject(err);
            });
    }
}

module.exports = DeleteAction;

DeleteAction.$inject = ["$teve.logger", "gameEditor.gameEditor"];

DeleteAction.$displayDetails = {
    type: "Action",
    name: "DeleteAction",
    icon: "common.trash_bin",
    title: "Delete File",
    shown: true,
    order: 1
};
